
import 'src/css/aiassistant.css';
import { withTranslation } from "react-i18next";
import { Col, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { createPopper } from '@popperjs/core';
import Draggable from 'react-draggable';
import UserMessage from './usermessage';
import AssinstantMessage from './assistantmessage';
import LoadingMessage from './loadingmessage';
import ChatsService from 'src/controllers/ChatController';

const messageTypes = {
    "Loading": LoadingMessage,
    "User": UserMessage,
    "Assistant": AssinstantMessage
}
class AiAssistant extends Component {
    constructor() {
        super();

        let y = -70;

        if (window.innerWidth > 1360 && window.innerWidth <= 1900)
            y = -100;
        if (window.innerWidth <= 1360)
            y = -120;

        this.state = {
            sessionId: crypto.randomUUID(),
            hovered: false,
            showChat: false,
            input_value: "",
            aiPosition: { x: 0, y: y },
            aiCursor: "pointer",
            height: 500,
            messages: []
        }

        this.showRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.popperInstance = React.createRef(null);
        this.divContent = React.createRef();
        this.lastMessage = React.createRef();
        this.setHovered = this.setHovered.bind(this);
        this.handleAiStop = this.handleAiStop.bind(this);
        this.handleAiStart = this.handleAiStart.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.addAssistantMessage = this.addAssistantMessage.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleResize = () => {
        let aiSaved = localStorage.getItem("ai-position");
        if (aiSaved) {
            try {
                let parsed = JSON.parse(aiSaved);

                if (parsed.x > window.innerWidth)
                    parsed.x = window.innerWidth - 100;

                if (parsed.y > -65) {
                    if (window.innerHeight > 900)
                        parsed.y = -70;

                    if (window.innerHeight <= 900)
                        parsed.y = -100;

                    if (window.innerHeight <= 800)
                        parsed.y = -120;
                    if (window.innerHeight <= 600)
                        parsed.y = -130;
                    if (window.innerHeight <= 500)
                        parsed.y = -150;
                }

                this.setState({ aiPosition: parsed });
            } catch (e) {
                console.error("Invalid ai saved position");
            }
        }
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.showChat) {
            this.popperInstance.current = createPopper(this.showRef.current, this.wrapperRef.current, {
                placement: 'auto',
                modifiers: [{
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                }, {
                    name: 'preventOverflow',
                    options: {
                        padding: 8,
                    },
                }]
            });
        } else {
            if (this.popperInstance.current) {
                this.popperInstance.current.destroy();
                this.popperInstance.current = null;
            }
        }

    }

    setHovered = (value) => {
        this.setState({
            hovered: value
        });
    }

    toggleChat = e => {
        this.setState({ showChat: !this.state.showChat });
    }

    handleInput = e => {
        e.preventDefault();
        let text = e.target.textContent;

        this.setState({
            input_value: text
        });
    }

    handleAiStop = (e, data) => {
        let newPos = { x: data.x, y: data.y };

        this.setState({
            aiPosition: newPos,
            aiCursor: "pointer"
        });

        localStorage.setItem("ai-position", JSON.stringify(newPos));
    };

    handleAiStart = (e, data) => {
        this.setState({
            aiCursor: "grabbing"
        })
    };

    toggleSize = e => {
        this.setState({ height: this.state.height === 500 ? 830 : 500 });
    }

    onKeyDown = e => {

        if (e.key === 'Enter' && !e.shiftKey && this.state.input_value !== null && this.state.input_value.trim() !== "") {

            let usermessage = {
                message: this.state.input_value || "",
                role: "User"
            };

            let loadingmessage = {
                message: "",
                role: "Loading"
            };

            this.setState(prevState => ({
                input_value: "",
                messages: [...prevState.messages, usermessage, loadingmessage]
            }));

            this.divContent.current.textContent = "";
            let messages = [...this.state.messages];

            messages.push(usermessage);

            let data = {
                "tenantId": this.props.tenantId,
                "sessionId": this.state.sessionId,
                "language": navigator.language,
                "messages": messages.filter(x => x.role !== "Loading" && x.message !== null)
            }

            ChatsService.askAssistant(data, this.addAssistantMessage);

            setTimeout(() => {
                this.lastMessage.current.scrollIntoView();
            }, 50);
        }
    }

    addAssistantMessage = data => {

        this.setState(prevState => {

            let updatedMessages = prevState.messages.filter((x, i) => x.role !== "Loading");

            let responseMessage = {
                message: data || "",
                role: "Assistant"
            };

            updatedMessages = [...updatedMessages, responseMessage];

            return {
                messages: updatedMessages
            };
        });
        setTimeout(() => {
            this.lastMessage.current.scrollIntoView();
        }, 500);

    }

    render() {
        return (<>
            {
                this.state.showChat &&
                <div ref={this.wrapperRef} className={"py-4 fs-6 w-325px show aichatwindow"} style={{ height: `${this.state.height}px` }}>
                    <div>
                        <Row>
                            <Col className="text-start text-primary">
                                <span class="fs-2"><FontAwesomeIcon size='lg' icon={duotone('microchip-ai')} /> {this.props.t("aiassistant")}</span>
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip style={{ position: "fixed" }}>
                                        {this.props.t("minimize")}
                                    </Tooltip>}>
                                    <Button variant='' size='sm' onClick={this.toggleChat} className='float-end'><FontAwesomeIcon icon={solid('angle-down')} /></Button>
                                </OverlayTrigger>

                                {
                                    this.state.height > 500 &&
                                    <Button variant='' size='sm' onClick={this.toggleSize} className='float-end'><FontAwesomeIcon icon={solid('arrow-down-left-and-arrow-up-right-to-center')} /></Button>
                                }

                                {
                                    this.state.height === 500 &&
                                    <Button variant='' size='sm' onClick={this.toggleSize} className='float-end'><FontAwesomeIcon icon={solid('up-right-and-down-left-from-center')} /></Button>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={`w-325px h-${this.state.height > 500 ? "700" : "375"}px aichat`}>
                                    {
                                        this.state.messages.map((x, i) => {
                                            let Message = messageTypes[x.role];
                                            return <Message key={i} message={x.message} />;
                                        })
                                    }
                                    <div ref={this.lastMessage} >
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div ref={this.divContent} onInput={this.handleInput} onKeyDown={this.onKeyDown} contentEditable={true} placeholder={this.props.t("writeamessage")} className='aiinput float-start text-gray-800' type="text" suppressContentEditableWarning={true}>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            }
            {
                this.props.aiEnabled &&
                <Draggable
                    handle=".drag"
                    position={this.state.aiPosition}
                    bounds="parent"
                    onStart={this.handleAiStart}
                    onStop={this.handleAiStop}
                >
                    <div className="drag" style={{ position: "absolute", zIndex: 3, cursor: this.state.aiCursor }}>
                        <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>{this.props.t("aiassistant")}</Tooltip>}>
                            <div ref={this.showRef} className='phoneicon' onMouseEnter={e => this.setHovered(true)} onMouseLeave={e => this.setHovered(false)} onClick={this.toggleChat} onKeyDown={this.onKeyDown}>
                                {
                                    (!this.state.hovered || (this.state.hovered && this.state.showChat)) &&
                                    <FontAwesomeIcon size='3x' icon={duotone('microchip-ai')} />
                                }

                                {
                                    (this.state.hovered && !this.state.showChat) &&
                                    <FontAwesomeIcon size='3x' icon={duotone('microchip-ai')} bounce />
                                }
                            </div>
                        </OverlayTrigger ></div>

                </Draggable>
            }
        </>);
    }
}

const mapStateToProps = (state) => {
    return {
        aiEnabled: state.parameters.aiEnabled,
        photo: state.agent.photo,
        initials: state.agent.initials,
        tenantId: state.agent.tenantId
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <AiAssistant {...props} navigate={navigate} />
}

export default compose(connect(mapStateToProps, {}), withTranslation())(WithNavigate);